import { Stack } from "@mui/material"
import { useTranslation } from "react-i18next"
import Card from "../global/Card"
import Title from "../global/Title"
import Text from "../global/Text"
import PieChart from "../global/PieChart"
import BarChartLegendItem from "../global/BarChartLegendItem"
import { colors } from "../../services/config/colors"
import {
  formatMobilityNumber,
  MobilityChartItem,
} from "../../services/utils/mobility"

// donut chart with the total in the middle and a legend with values and percentages
const MobilityDonutCard = ({
  title,
  items,
  unit,
  loading,
  width,
}: {
  title: string
  items: MobilityChartItem[]
  unit: string
  loading: boolean
  width?: string
}) => {
  const { t } = useTranslation()
  const total = items.reduce((sum, item) => sum + item.value, 0)

  return (
    <Card gap={2} width={width}>
      <Title>{title}</Title>
      <Stack alignItems="center" style={{ width: "100%" }}>
        <div
          className="center"
          style={{
            width: 280,
            minWidth: 280,
            height: 280,
            position: "relative",
          }}
        >
          <div style={{ width: 360, height: 360, position: "absolute" }}>
            <PieChart
              data={items.map((item) => ({
                label: item.label,
                value: item.value,
                backgroundColor: item.color,
              }))}
              loading={loading}
              skeletonDimension={360}
            />
          </div>
          {!loading && (
            <Stack
              style={{ position: "absolute" }}
              alignItems="center"
              gap={0.25}
            >
              <Title fontSize={total ? 26 : 20} lineHeight="30px">
                {total ? formatMobilityNumber(total, 0) : t("no_data")}
              </Title>
              {total ? (
                <Text
                  fontSize={12}
                  lineHeight="14px"
                  fontWeight={500}
                  color={colors.textSecondary}
                >
                  {unit}
                </Text>
              ) : null}
            </Stack>
          )}
        </div>
        {!loading && total ? (
          <Stack gap={1} style={{ width: "100%", marginTop: 8 }}>
            {items.map((item) => (
              <Stack
                key={item.id}
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                gap={1}
              >
                <BarChartLegendItem label={item.label} color={item.color} />
                <Text fontSize={14} fontWeight={500}>
                  {formatMobilityNumber(item.value)} {unit}{" "}
                  <span style={{ color: colors.textSecondary }}>
                    ({formatMobilityNumber((item.value / total) * 100)}%)
                  </span>
                </Text>
              </Stack>
            ))}
          </Stack>
        ) : null}
      </Stack>
    </Card>
  )
}

export default MobilityDonutCard
